export default function getNavigatorLanguage() {
  const language = navigator.userLanguage ? navigator.userLanguage : navigator.language;
  return language.toLowerCase().substr(0, 2);
}
